"use client";

import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

const useGetSearchParams = () => {
  const searchParams: any = useSearchParams();
  // state
  /////////////////////////
  const [sParams, setSParams] = useState({});
  const getSearchParamsFormUrl = () => {
    let Params: any = {};

    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      Params[`${param}`] = value;
    }
    setSParams(Params);
  };

  useEffect(() => {

    getSearchParamsFormUrl();
  }, [searchParams.toString]);

  return { ...sParams };
};

export default useGetSearchParams;
